export default __webpack_public_path__ + "static/media/2dArt.96b456d1.png";